<ins-header>
	<ins-toolbar>
		<ins-title class="modal__title">{{ title() }}</ins-title>
		@if (closeVisible()) {
			<button
				slot="end"
				type="button"
				tabindex="-1"
				class="ins-close-btn"
				(click)="close()">
				<skl-icon name="cross"></skl-icon>
			</button>
		}
	</ins-toolbar>
</ins-header>